import { Component } from '@angular/core';

@Component({
	selector: 'vcm-programming-hints',
	template: require('./programming-hints.component.html')
})

export class ProgrammingHintsComponent  {
}
